import { render, staticRenderFns } from "./AddSnoozeNotification.vue?vue&type=template&id=233c179c&scoped=true&lang=pug"
import script from "./AddSnoozeNotification.vue?vue&type=script&lang=js"
export * from "./AddSnoozeNotification.vue?vue&type=script&lang=js"
import style0 from "./AddSnoozeNotification.vue?vue&type=style&index=0&id=233c179c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c179c",
  null
  
)

export default component.exports